import React from "react";
import { useFeatureFlags } from "../context/FeatureFlagsContext";
import { WalletPanel } from "./WalletPanel";

/**
 * Player-facing /wallet route. Renders the WalletPanel when the
 * global `tips_enabled` feature flag is on. While the flag is off
 * the page returns a 404-style "not available" view so the URL
 * stays unguessable and crawlers can't index a half-finished
 * feature. Internal staff can browse to `/wallet` to verify the
 * gate behaves correctly.
 */
export default function WalletPage({ onToast }) {
  const { flags } = useFeatureFlags();
  if (!flags?.tips_enabled) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center text-center px-4">
        <div data-testid="wallet-disabled-placeholder">
          <p className="text-[10px] tracking-[4px] text-white/40">404</p>
          <p className="mt-1 text-white/60">This page isn't available yet.</p>
        </div>
      </div>
    );
  }
  return (
    <div className="max-w-2xl mx-auto px-4 py-6">
      <h1 className="text-2xl font-black text-white mb-1" data-testid="wallet-page-title">
        WALLET
      </h1>
      <p className="text-[12px] text-white/50 mb-5">
        Your tip earnings and payout history.
      </p>
      <WalletPanel onToast={onToast} />
    </div>
  );
}
